import wgcwxShop from './shop'
import wgcwxShopRewards from './rewards'
import wgcwxShopProducts from './products'
import wgcwxInventoryStyles from './inventory_styles'
import wgcwxPreloadImages from './preload_images'
import wgcwxClanInfo from './clan'

export const reducers = {
    wgcwxShop,
    wgcwxShopProducts,
    wgcwxShopRewards,
    wgcwxInventoryStyles,
    wgcwxPreloadImages,
    wgcwxClanInfo,
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_shop/index.js